import icon1 from "../assets/icons/icon1.svg";
import icon10 from "../assets/icons/icon10.svg";
import icon11 from "../assets/icons/icon11.svg";
import icon13 from "../assets/icons/icon13.svg";
import icon2 from "../assets/icons/icon2.svg";
import icon3 from "../assets/icons/icon3.svg";
import icon4 from "../assets/icons/icon4.svg";
import icon5 from "../assets/icons/icon5.svg";
import icon7 from "../assets/icons/icon7.svg";
import icon8 from "../assets/icons/icon8.svg";
import icon9 from "../assets/icons/icon9.svg";
import iconGraduated from "../assets/icons/graduate.svg";
import iconServices from "../assets/icons/app.svg";
import iconServicesRequest from "../assets/icons/servicesRequest.svg";
import iconservicesApp from "../assets/icons/app+.svg";
import iconProgram from "../assets/icons/menus.svg";
import iconAppProgram from "../assets/icons/menus+.svg";
import iconNeeds from "../assets/icons/results.svg"
import iconAllneeds from "../assets/icons/list-text.svg";
import iconDeleteUser from "../assets/icons/Deleteuser.svg";
import iconEndowment from "../assets/icons/endowment-icon.svg";
import iconShare from "../assets/icons/stocks-icon.svg";
export const beneficiaryMenu = (club?: any) => [
  { key: "b", title: "القائمة الرئيسية", icon: icon1 },
  { key: "b1", title: "لوحة المعلومات", icon: icon1 },
  { key: "b2", title: "أوراق الثبوتية", icon: icon9 },
  { key: "b3", title: "الحسابات البنكية", icon: icon5 },
  {
    key: "nb",
    title: "الخدمات",
    icon: iconServices,
    children: [
      { key: "b6", title: "الخدمات", icon: iconServices },
      { key: "b10", title: "الترشحات للخدمات", icon: iconservicesApp },
      { key: "b5", title: "الطلبات الشخصية", icon: iconServicesRequest },
    ],
  },
  {
    key: "nb1",
    title: "البرامج",
    icon: iconProgram,
    children: [
      { key: "b11", title: "البرامج", icon: iconProgram },
      { key: "b12", title: "الترشحات للبرامج", icon: iconAppProgram },
    ],
  },
  {
    key: "nb3",
    title: "التبرعات",
    icon: icon7,
    children: [
      { key: "b18", title: "التبرعات النقدية", icon: icon7 },
      { key: "b19", title: "التبرعات العينية", icon: icon7 },
    ],
  },
  {
    key: "b13",
    title: "التسجيل على المنح",
    icon: icon11,
    disabled: club?.open_scholarship_inscription,
  },
  {
    key: "b15",
    title: "التسجيل في الجامعات",
    icon: iconGraduated,
    disabled: club?.open_university_inscription,
  },
  {
    key: "nb4",
    title: "المتابعة التعليمية",
    icon: icon11,
    disabled : club?.open_dropout || club?.open_education_monitoring ,
    children: [
      {
        key: "b14",
        title: "المتابعة التعليمية",
        icon: icon11,
        disabled: club?.open_education_monitoring,
      },
      {
        key: "b16",
        title: "المنقطعين عن الدراسة",
        icon: icon11,
        disabled: club?.open_dropout,
      },]
  },

  { key: "b7", title: "تواصل معنا", icon: icon8 },
  { key: "b8", title: "رأيك يهمنا", icon: icon10 },
  { key: "b9", title: "تسجيل الخروج", icon: icon13 },
];

export const sponsorMenu = [
  { key: "s", title: "القائمة الرئيسية", icon: icon1 },
  { key: "s1", title: "لوحة المعلومات", icon: icon1 },
  {
    key: "ns1",
    title: "الكفالات",
    icon: icon2,
    children: [
      { key: "s2", title: "كفالاتي" , icon :icon2 },
      { key: "s3", title: "تجديد كفالاتي" , icon :icon3},
     // { key: "s18", title: "إضافة يتيم جديد" , icon :icon2},
      { key: "s17", title: "إلغاء كفالاتي" , icon :iconDeleteUser},
    ],
  },
  { key: "s4", title: "البيانات الشخصية", icon: icon4 },
  {
    key: "ns2",
    title: "إحتياجات الأيتام و الأرامل",
    icon: icon5,
    children: [
      { key: "s5", title: "إحتياجات أيتامي و أراملي", icon :iconNeeds },
      { key: "s6", title: "كل إحتياجات الأيتام و الأرامل" , icon :iconAllneeds },
    ],
  },
  { key: "s16", title: "أنشطة أيتامي وأراملي", icon: icon11 },
  { key: "s7", title: "تفاصيل التبرعات", icon: icon7 },
  { key: "s14", title: "تفاصيل دفعات الكفالة", icon: icon7 },
  { key: "s24", title: "مدفوعات النظام القديم", icon: icon7 },
  { key: "s20", title: "تفاصيل المصروفات", icon: icon7 },
  { key: "s15", title: "", icon: icon8 },
  { key: "s8", title: "تواصل معنا", icon: icon8 },
  { key: "s9", title: "التقارير", icon: icon9 },
  { key: "s10", title: "رأيك يهمنا", icon: icon10 },
  { key: "s11", title: "شهادة الشكر", icon: icon11 },
  { key: "s19", title: "الأوقاف", icon: iconEndowment },
  { key: "s13", title: "تسجيل الخروج", icon: icon13 },
];

// Shares / photos / videos pages of every role that contains "participant"
export const participantMenu = [
  { key: "s23", title: "الأسهم", icon: iconShare },
  { key: "s21", title: "الصور", icon: icon11 },
  { key: "s22", title: "الفيديوهات", icon: icon11 },
];
export const hasParticipantRole = (role: string) =>
  role?.includes("participant");
// Add the participant pages before the logout item of a sponsor menu
export const withParticipantMenu = (menu: any[], role: string) => {
  if (!hasParticipantRole(role)) return menu;
  const logoutIndex = menu.findIndex((item) => item.key === "s13");
  if (logoutIndex === -1) return [...menu, ...participantMenu];
  return [
    ...menu.slice(0, logoutIndex),
    ...participantMenu,
    ...menu.slice(logoutIndex),
  ];
};
// Hide the old system payments page when the sponsor has none
export const withOldSystemPayments = (menu: any[], sponsor: any) =>
  sponsor?.has_old_system_payments
    ? menu
    : menu.filter((item) => item.key !== "s24");
export const getMenu = (role: string) => {
  switch (role) {
    case "endower":
      return sponsorMenu.filter(
        (item) =>
          item.key === "s" ||
          item.key === "s1" ||
          item.key === "s9" ||
          item.key === "s7" ||
          item.key === "s10" ||
          item.key === "s19" ||
          item.key === "s13" ||
          item.key === "s4"

      );
    case "endower_participant":
      return [
        ...sponsorMenu.filter(
          (item) =>
            item.key === "s" ||
            item.key === "s1" ||
            item.key === "s9" ||
            item.key === "s7" ||
            item.key === "s10" ||
            item.key === "s19" ||
            item.key === "s4"

        ),
        ...participantMenu,
        ...sponsorMenu.filter((item) => item.key === "s13"),
      ];
    case "donor":
      return sponsorMenu.filter(
        (item) =>
          item.key === "s" ||
          item.key === "s1" ||
          item.key === "s9" ||
          item.key === "s7" ||
          item.key === "s10" ||
          item.key === "s13" ||
          item.key === "s4"

      );
    case "participant":
      return [
        ...sponsorMenu.filter(
          (item) =>
            item.key === "s" ||
            item.key === "s1" ||
            item.key === "s9" ||
            item.key === "s7" ||
            item.key === "s10" ||
            item.key === "s4"
        ),
        ...participantMenu,
        ...sponsorMenu.filter((item) => item.key === "s13"),
      ];
  }
};

export const schoolMenu = [
  { key: "s", title: "القائمة الرئيسية", icon: icon1 },
  { key: "s1", title: "لوحة المعلومات", icon: icon1 },
  { key: "sm", title: "الطلاب", icon: icon11 },
  { key: "sm1", title: "الملاحظات", icon: icon1 },
  ];